import React from "react";
import Box from "@material-ui/core/Box";
import PlansManagerImproved from "../PlansManager/PlansManagerImproved";

// La facturación se retiró (doc 0431, Fase 4b): de esta pestaña solo queda la
// gestión de planes, que son límites por empresa, no cobro.
export default function SubscriptionsConfig() {
  return (
    <Box style={{ marginTop: 8 }}>
      <PlansManagerImproved />
    </Box>
  );
}
